if ($('section#seo-content').length && $('#seo-content').prev('section').length) {
  $(function(){
    if($('#seo-content').prev('section').css('background-color') === 'rgba(0, 0, 0, 0)'){
      $('#seo-content').addClass('bg-grey');
    }
  });
}
